/*
 * 邀请成员相关
 */

(function($) {

$(function() {
    // 注意：如果换用document，submit将无法中断
    $('body')
    .on('submit', '.form-invite', function(e) {
        var form = $(this),
            valid = true,
            emailElems = form.find('input.invite-email');

        emailElems.first().closest('.form-item')
            .find('.error').remove();

        emailElems = $.grep(emailElems, function(el) {
            return $.trim($(el).val()) !== '';
        });

        // 只有团队邀请页面和初始化邀请需要，项目成员邀请不需要
        var pageId = tower.stack.currentPage.el.children().first().attr('id');
        if (!emailElems.length && !/page-new-project|page-project-members/.test(pageId)) {
            $('<p class="error">请至少邀请一个人</p>').appendTo(form.find('.invite-item:first'));
            return false;
        }

        $.each(emailElems, function() {
            var el = $(this);
            var val = el.val();
            var email = $.trim(val);
            var wrap = el.parent();
            var start;

            if (!tower.validate.email(email).valid) {
                start = val.indexOf(email);
                tower.selectText(el, start, email.length);

                wrap.append('<p class="error">请输入一个有效的邮箱地址</p>');
                valid = false;
                return false;
            }

            if (/@mailer.tower.im$/.test(email)) {
                start = val.indexOf( email );
                tower.selectText(el, start, email.length);

                wrap.append('<p class="error">这是 Tower <a href="/roadmap#TWR0028" target="_blank">私人收件箱功能</a>专用的地址，不能用于账号注册</p>');
                valid = false;
                return false;
            }
        });

        simple.util.storage.remove('invites');
        return valid;
    })
    .on('ajax:beforeSend', '.form-invite', function(e, xhr, settings) {
        var emails = [],
            roles = [];

        $('.invite-item').each(function() {
            var it = $(this),
                email = $.trim(it.find('input.invite-email').val()),
                role = it.find('select.invite-role').val();

            if (email) {
                emails.push(email);
                roles.push(role);
            }
        });

        emails = emails.join(',');
        roles = roles.join(',');

        settings.data += '&emails=' + encodeURIComponent(emails) +
            '&init_roles=' + encodeURIComponent(roles);
    })
    .on('ajax:error', '.form-invite', function(e, xhr) {
        if (!xhr.responseText) return;
        var form = $( e.currentTarget ),
            errors = JSON.parse( xhr.responseText ).errors;

        if (errors && errors.length) {
            var err = errors[0];

            if (err.target && err.target === 'emails') {
                var emails = err.emails;

                $.each(form.find('input.invite-email'), function(idx, input) {
                    var $input = $(input);
                    var email = $.trim($input.val());
                    var i = emails.indexOf(email);

                    if (i >= 0) {
                        $('<p class="error">' + err.msg + '</p>').appendTo($input.parent());
                        emails.splice(i,1);
                    }
                });

                if (emails.length) {
                    $('#label-email').next('.error').remove()
                        .end().after('<p class="error">' + emails.join('、') + err.msg + '</p>');
                }

                return false;
            }
        }
    })
    .on('click', '.form-invite #add-invite-item', function(e) {
        e.preventDefault();

        var target = $(e.target),
            wrap = target.closest('.form-item'),
            oldItem = wrap.find('.invite-item:last'),
            newItem = oldItem.clone(true),
            newInput = newItem.find('input').val('');

        newItem.find('.error').remove();
        newItem.insertAfter(oldItem);

        wrap.find('.invite-item:not(:has(.del-invite))')
            .append('<a href="javascript:;" class="del-invite">删除</a>');

        newItem.find('.invite-email').focus();
    })
    .on('click', '.form-invite .del-invite', function(e) {
        e.preventDefault();

        var target = $(e.target),
            item = target.closest('.invite-item'),
            others = item.siblings();

        item.fadeTo(200, 0)
            .slideUp(200, function() {
                item.remove();

                if (others.length === 3) {
                    others.find('.del-invite').remove();
                }
            });
    })
    .on('click', '.form-invite .link-show-invite', function(e) {
        e.preventDefault();
        $(e.target).hide().nextAll('.form-item').show();
    });
});

})(jQuery);
